module.exports = __webpack_public_path__ + "static/media/info_icon.04a36d03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info_icon.svg
// module id = 230
// module chunks = 0